import { render, staticRenderFns } from "./CustomerPricingHistoryDialog.vue?vue&type=template&id=6e993011&"
import script from "./CustomerPricingHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomerPricingHistoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports